import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';
import { Form, Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import { FormAlert, NewInputText, parseFinalFormErrors } from '@saucelabs/sl-component-form';
import { Button } from '@saucelabs/ds-button';

import { trackEvent, EVENTS } from '../tracking';
import { sanitizeInputAlphanumeric } from '../utils';
import Styles from './CouponCode.styles';

const debouncedOnFieldChange = debounce((value) => (
  trackEvent(EVENTS.CHECKOUT_UPDATE_FORM_FIELD, { fieldName: 'coupon', value })
), 1000);

const CouponCode = ({ applyCoupon }) => (
  <Form
    onSubmit={(values) => (
      applyCoupon(values.coupon)
        // react-final-form requires forms to resolve with no value on success
        .then(() => null)
        .catch(({ response }) => {
          let errorMessage = response?.data?.detail?.[0]?.message;
          if (errorMessage === 'Coupon code cannot be applied.') {
            errorMessage = `${values.coupon} is invalid.`;
          }
          const parsedErrors = parseFinalFormErrors({}, errorMessage);
          return parsedErrors;
        })
    )}
    render={({ form, handleSubmit }) => {
      const { error, pristine, submitError, submitting } = form.getState();

      return (
        <form
          data-qa="couponCodeForm"
          onSubmit={handleSubmit}
        >
          <div className={Styles['form-container']}>
            <div className={Styles['input-container']}>
              <Field
                className={Styles['coupon-code-input']}
                component={NewInputText}
                label="Coupon Code"
                name="coupon"
                parse={sanitizeInputAlphanumeric}
                type="text"
              />
              <OnChange name="coupon">
                {(value, previous) => {
                  if ((value || '') !== (previous || '')) {
                    debouncedOnFieldChange(value);
                  }
                }}
              </OnChange>
            </div>
            <Button
              className={Styles['apply-button']}
              color="secondary"
              disabled={pristine || submitting}
              onPress={handleSubmit}
              variant="text"
            >
              APPLY
            </Button>
          </div>
          <FormAlert type="danger">{error || submitError}</FormAlert>
        </form>
      );
    }}
  />
);

CouponCode.propTypes = {
  applyCoupon: PropTypes.func.isRequired,
};

export default CouponCode;
